module.exports = __webpack_public_path__ + "img/KMC.ed0cfde.jpg";